import { useDispatch, useSelector } from "react-redux";
import {
  ApiCallState,
  isApiCallCompletedSuccessfully,
  isApiCalled,
  isApiCallFailed,
  isApiCallLoading,
} from "src/common/ApiCall";
import { RootState } from "src/redux/store";
import { SystemResourcesActions } from "./../../models/system-resources";

export function useFetchAllSystemResourcesApiCallState(): ApiCallState {
  const { progress, error } = useSelector(
    (rootState: RootState) => rootState.systemResources.systemResourcesPEV
  );

  const dispatch = useDispatch();

  function dispatchApiCall(resetApiCall: Boolean) {
      if (!isApiCalled(progress) || resetApiCall) {
      dispatch(SystemResourcesActions.getAllSystemResources());
    }
  }

  return new ApiCallState(
    isApiCalled(progress),
    isApiCallFailed(error),
    isApiCallLoading(progress),
    isApiCallCompletedSuccessfully(progress, error),
    dispatchApiCall
  );
}
